import  gql  from 'graphql-tag'

export const systemSettings = gql`query{
    systemSettings{
      versionId
      idleTime
      alert
      salary
      ipc
    }
  }`;
